define 'controller/SortingController', ['jquery', 'lib/kryptonite'], ($) ->
  class SortingController
    constructor: (@$el) ->
      self = @
      @$rightPanel = $('#modalOverlayRight')
      @$categoryOptions = @$el.closest("[data-controller-element=category-options]")
      @$filterSortingButtonLabel = @$categoryOptions.find("[data-controller-element=filter-sorting-button-label]")
      @$sortingDropdownWrapper = @$el.find("[data-controller-element=sorting-dropdown-wrapper]")
      @$sortingOpenButton = @$el.find("[data-controller-element=sorting-open-button]")

      @_handleAccessibilityForABCtest()
      @_sortSelect()
      @_closeMobileLayer()
      @_sortSelectRadio()
      @_handleSortingInFilterLayer()

    _handleSortingInFilterLayer: ->
      self = @
      @$rightPanel.on 'modal:body-filled', (e) ->
        if $(@).find('[data-controller-element=sort-filter-layer]').length > 0 && self.$categoryOptions.hasClass('sort-filters-panel')
          $(@).find('[data-controller-element=sort-filter-layer]').addClass('active')
      @$rightPanel.on "hide.bs.modal", (e) ->
        $(@).find('[data-controller-element=sort-filter-layer]').removeClass('active')

    _sortSelectRadio: ->
      self = @
      $('[data-controller-element=sorting-radio-wrapper]').on 'change', '[name="categorySorting"]', (e) ->
        url = $(@).val()
        $('#modalOverlayRight').modal('hide')
        self._send(url)

    _handleAccessibilityForABCtest: ->
      self = @
      window.setTimeout(
        ->
          if self.$categoryOptions.hasClass('sort-dedicated-panel')
            self.$sortingDropdownWrapper.attr('aria-hidden', true)
          else
            self.$sortingOpenButton.attr('aria-hidden', true)

          if self.$categoryOptions.hasClass("sort-filters-panel")
            self.$sortingDropdownWrapper.attr('aria-hidden', true)
            self.$sortingOpenButton.attr('aria-hidden', true)
            self.$filterSortingButtonLabel.siblings().attr("aria-hidden", true)
            self.$filterSortingButtonLabel.closest('[data-controller-element=filter-open-button]').data('modal-title', 'Trier / Filtrer')
          else
            self.$filterSortingButtonLabel.attr('aria-hidden', true)
            $('[data-controller-element=sort-filter-layer]').attr('aria-hidden', true)

      , 300
      )

    _closeMobileLayer: ->
      $('.sorting__layer-header').on 'click', ->
        $('.dropdown__content').removeClass('dropdown__content--visible')
        $('.dropdown__icon').removeClass('dropdown__icon--opened')

    _sortSelect: ->
      self = @
      @$el.on 'click', '.sorting__item', (e) ->
        url = $(@).data 'url'
        self._send(url)

    _send: (url) ->
      self = @
      # reload for older browsers
      unless history.pushState?
        window.location = url
        return

      history.pushState(null, null, url)
      $('body').addClass('loading')
      $.kryptonite
        url: url
        type: 'POST'
        beforeSend: ->
          self.destroy()
        complete: (response) ->
          $('body').removeClass('loading')

    destroy: ->
      @$el.off()
